import { takeEvery, put } from "redux-saga/effects";
import { request } from "../../../api/Service";
import { getErrorMessage } from "../../../components/utils/errorHandler";
import { toast } from "react-toastify";
import history from "../../../router/browserrouter";

export default function* watcherAddFulfilOrderSaga() {
    yield takeEvery("FULFIL_ORDER", workerSaga);
}

function* workerSaga(action) {
    try {
        yield put({ type: "DISPLAY_LOADER", payload: payload });
        var payload = {};
        var formatUrl = "api/SalesTransactionV2/fufil-order";
        yield request("post", action.payload, formatUrl).then((response) => {
            payload = response;
        });
        alert(payload)
        var formatUrl = `api/SalesTransactionV2/online?companyId=${action.payload.companyId}`;
        yield request("get", {}, formatUrl).then((response) => {
            payload = response;
        });
        yield put({ type: "ONLINE_PAYMENT_LIST", payload: payload });
        history.push("/online-payments")
    } catch (e) {
        console.log(e);
        console.log("product-saga", e);
        console.log("product-saga", e.response);
        yield put({ type: "LOADING_BUTTON_SPINNER" });
        const errorMessage = getErrorMessage(e.response);
        alert(errorMessage)
        toast.error(errorMessage);
        yield put({ type: "API_ERRORED", payload: e });
        yield put({ type: "DISPLAY_LOADER", payload: payload });
    }
}

